import { createFileRoute } from "@tanstack/react-router";
import NegotiationsPage from "@/components/negotiations/negotiations-page";

function BrokerSentNegotiationsPage() {
  return <NegotiationsPage viewMode="carrier" />;
}

export const Route = createFileRoute("/_app/negotiations/sent")({
  component: BrokerSentNegotiationsPage,
});
